import { Outlet, useNavigate } from "react-router-dom";
import _ from "lodash"
import Header from "../../components/logistics/Header";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import Footer from "../../components/logistics/Footer";
import Settings from "../../components/management/Settings";
import { useEffect, useState } from "react";
import ThemeProvider from "../../hooks/themeProvider";
import PageLoader from "../../components/PageLoader";
import { getBrandMapping } from "../../common/services/website-card.service";
import { metaTokens } from "../../redux/meta-token/action";
import { getGatewayId, getGatewayuri, getHostName, getOrigin } from "../../common/services/common.service";
import moment from "moment";
import { websites } from "../../redux/websites/action";
import { websiteCards } from "../../redux/websiteCards/action";
import ManagementLogin from "../../pages/auth/management";

const LogisticsLayout = () => {

	const dispatch = useAppDispatch()
	const result = useSelector(selectCurrent)
	const { header, footer, visible, sidebar, theme, isThemeAvailable, tenantId } = result
	const dummyImage = require(`../../assets/img/image.png`)


	const prepareTheme = async (cards: any) => {
		let _isThemeSelected = false
		const themes = await getBrandMapping(cards, 'MOBILITY_SMP_HOME_BRAND_MAPPINGS')
		await _.map(themes, async (theme: any) => {
			console.log('setting dynamic theme', theme)
			await dispatch(settings.set({
				theme: theme?.themeName?.toLowerCase() || 'universal',
				darkLogo: theme.logoDark,
				lightLogo: theme.logoLight,
				favIcon: theme.favIconDark || theme.favIconLight,
				isThemeAvailable: true,
			}))
			_isThemeSelected = true

			localStorage.setItem("theme", theme?.themeName?.toLowerCase() || 'universal')
		})
		if (!_isThemeSelected) {
			prepareDefaultTheme()
		}
	}

	const prepareDefaultTheme = () => {
		dispatch(settings.set({
			theme: 'universal',
			darkLogo: dummyImage,
			lightLogo: dummyImage,
			favIcon: '/assets/images/16x16.png',
			isThemeAvailable: true,
		}))
	}

	useEffect(() => {
		const loadSequentially = async () => {

			if (!tenantId || tenantId === -1) return;
			try {
				await dispatch(metaTokens.resetAction({ actionType: 'list' }));
				const metaData: any = await dispatch(metaTokens.list({
					url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/token-service/meta-token`, entity: 'metaTokens', jsonData: {
						"Records": [
							{
								"Context": {

									"domain": "string",
									"core_version": "string",
									"Gateway_id": getGatewayId(),
									"Gateway_uri": getGatewayuri(),
									"bap_id": getHostName(),
									"bap_uri": getOrigin(),
									"bpp_id": "string",
									"bpp_uri": "string",
									"city": "string",
									"country": "string",
									"action": "string",
									"transaction_id": "string",
									"message_id": "string",
									"timestamp": moment.utc(),
									"ttl": "string",
									"Subscription": "MoveX",
									"Domain": "Mobility",
									"SubDomains": [
									],
									"Network": "RAPCustomer",
									"Application": "Customer",
									"Channel": "CSP"
								},
								"Message": {
								}
							}
						]
					}
				}))
				const firstWebsiteId = metaData?.items?.Website?.Id;
				await dispatch(websites.resetAction({ actionType: 'list' }));
				await dispatch(websiteCards.resetAction({ actionType: 'list' }));
				const cardsData: any = await dispatch(websiteCards.list({
					url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/fetch`, entity: 'websiteCards', jsonData: {
						"Records": [
							{
								"Context": {
								},
								"Message": {
									"TenantId": tenantId,
									"Id": firstWebsiteId
								}
							}
						]
					}, options: { authorization_required: false }
				}))

				if (cardsData?.items?.length > 0) {

					prepareTheme(cardsData?.items);
				} else {
					prepareDefaultTheme();
				}

			} catch (error) {
				console.error('Error during sequential loading', error);
				prepareDefaultTheme();
			}
		};

		loadSequentially();

	}, [dispatch, tenantId]);

	if (!isThemeAvailable) {
		console.log('theme not loaded')
		return (
			<>
				<PageLoader />
			</>
		)
	}

	return (
		<>
			<ThemeProvider>
				<div className="leading-normal tracking-normal" id="main-body">
					<div className="flex flex-wrap sm:hide">
						{visible ? <Settings /> : <></>}
						<div className="w-full bg-gray-100  min-h-screen" id="main-content">
<ManagementLogin/>
						
						</div>
					</div>
				</div>
			</ThemeProvider>
		</>
	)
}
export default LogisticsLayout;